import { render, staticRenderFns } from "./AppBadge.vue?vue&type=template&id=36e0ee50&scoped=true"
import script from "./AppBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppBadge.vue?vue&type=style&index=0&id=36e0ee50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0ee50",
  null
  
)

export default component.exports